import React from 'react';

export default function UploadContasEnviadas() {
  return (
    <div style={{ padding: '48px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 420 }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>📤</div>
      <div style={{ display: 'inline-block', background: '#fef9c3', color: '#a16207', padding: '4px 14px', borderRadius: 20, fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .6, marginBottom: 14 }}>Em elaboração</div>
      <div style={{ fontWeight: 800, fontSize: '1.3rem', color: '#1e293b', marginBottom: 8, textAlign: 'center' }}>Upload de Contas Enviadas</div>
      <div style={{ color: '#64748b', fontSize: '0.88rem', textAlign: 'center', maxWidth: 480, lineHeight: 1.6 }}>
        Importe planilhas de contas enviadas às operadoras. Esta funcionalidade está em desenvolvimento e será disponibilizada em breve.
      </div>
    </div>
  );
}
